import request from '@/utils/request';
import config from '@/config';

const { apiInfo } = config;
const planCenterUrl = `${apiInfo.planCenter.prefix}${apiInfo.planCenter.group}`;

export function getPlanInfo(planID) {
    const url = planCenterUrl + `/PlanInfo?planID=${planID}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getTopsheet(
    PlanName,
    ApproveStatus,
    CreateUserID,
    PlanType,
    PlanCountry,
    CreateMonthB,
    CreateMonthE,
    LastModifiedB,
    LastModifiedE,
    PlanOwnerUser,
    pageIndex,
    pageSize
) {
    const url =
        planCenterUrl +
        `/Topsheet?PlanName=${PlanName}&ApproveStatus=${ApproveStatus}&CreateUserID=${CreateUserID}&PlanType=${PlanType}&PlanCountry=${PlanCountry}&CreateMonthB=${CreateMonthB}&CreateMonthE=${CreateMonthE}&LastModifiedB=${LastModifiedB}&LastModifiedE=${LastModifiedE}&PlanOwnerUser=${PlanOwnerUser}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}
export function getDATExport(data) {
    const url = planCenterUrl + '/DATReport';

    return request({
        url: url,
        method: 'post',
        data: data
    });
}

export function getPlanList(
    PlanName,
    ApproveStatus,
    CreateUserID,
    PlanType,
    PlanCountry,
    CreateMonthB,
    CreateMonthE,
    LastModifiedB,
    LastModifiedE,
    pageIndex,
    pageSize
) {
    const url =
        planCenterUrl +
        `/PlanList?PlanName=${PlanName}&ApproveStatus=${ApproveStatus}&CreateUserID=${CreateUserID}&PlanType=${PlanType}&PlanCountry=${PlanCountry}&CreateMonthB=${CreateMonthB}&CreateMonthE=${CreateMonthE}&LastModifiedB=${LastModifiedB}&LastModifiedE=${LastModifiedE}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getCheckList(
    Country,
    Category,
    PlanType,
    PlanName,
    pageIndex,
    pageSize
) {
    const url =
        planCenterUrl +
        `/CheckList?country=${Country}&category=${Category}&planType=${PlanType}&planName=${PlanName}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}



// WEBPACK FOOTER //
// ./src/api/planCenter.js